import React from 'react'
import Footer from '../components/Footer'
import { motion } from 'framer-motion';
import aboutImage from '../images/about.jpg';
import { Link } from 'react-router-dom';

const About = () => {

  const fadeInUp = {
    hidden: { opacity: 0, y: -40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
  };

  const slideInLeft = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: 'easeOut' } },
  };

  const slideInRight = {
    hidden: { opacity: 0, x: 50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: 'easeOut' } },
  };
  return (
    <>

      <section className="py-5" id="about" aria-labelledby="about-heading">

        <h2 className='text-center mt-4'>About Us </h2>
        <div className="container">
          {/* Section Header */}
          <motion.div
            className="text-center mb-5"
            initial="hidden"
            whileInView="visible"
            variants={fadeInUp}
            viewport={{ once: true, amount: 0.3 }}
          >
            {/* <h2 id="about-heading" className="display-4 fw-bold text-dark mb-3">
            About Us
          </h2> */}
            <p className="lead text-muted">
              We are committed to providing high-quality, patient-centered healthcare services
              with a focus on compassion and innovation.
            </p>
          </motion.div>

          {/* Content Row */}
          <div className="row g-4 align-items-center">
            {/* Image */}
            <motion.div
              className="col-md-6"
              initial="hidden"
              whileInView="visible"
              variants={slideInLeft}
              viewport={{ once: true, amount: 0.2 }}
            >
              <img
                src={aboutImage}
                alt="Healthcare professionals"
                className="img-fluid rounded shadow"
              />
            </motion.div>

            {/* Text Content */}
            <motion.div
              className="col-md-6"
              initial="hidden"
              whileInView="visible"
              variants={slideInRight}
              viewport={{ once: true, amount: 0.2 }}
            >
               <h3 className="h4 fw-semibold text-dark mb-3">Shree Radha Krishna Sewa Sansthan
            </h3>
            <p className="text-muted mb-4">
           Shree Radha Krishna Sewa Sansthan is a dedicated spiritual organization committed to the service and worship of Lord Radha and Lord Krishna. Our primary mission is to foster devotion, love, and peace through the teachings and practices of the divine couple. We aim to spread the message of harmony, compassion, and devotion, transcending religious boundaries and reaching individuals from all walks of life.
            </p>

            <p className="text-muted mb-4">At the heart of our foundation lies the belief in the profound power of Bhakti (devotion) as a path to spiritual enlightenment and inner peace. We offer a wide range of religious, cultural, and social activities designed to nurture the spiritual growth of our members, inspire love and selfless service, and contribute to the welfare of society.</p>

              
            </motion.div>
          </div>
        </div>

        <hr /><br /><br /><br />

        <section class="container my-5">
          <div class="row text-center mb-4">
            <div class="col">
              <h2 class="fw-bold text-primary">Natural Tooth</h2>
              <p class="text-muted">Committed to Compassionate Healthcare</p>
            </div>
          </div>

          <div class="row g-4">

            <div class="col-md-6">
              <div class="card h-100 shadow-sm">
                <div class="card-body">
                  <h4 class="card-title text-success">Our Vision</h4>
                  <p class="card-text">
                    To become a trusted leader in multispeciality healthcare by delivering world-class medical services with compassion, innovation, and excellence.
                  </p>
                </div>
              </div>
            </div>


            <div class="col-md-6">
              <div class="card h-100 shadow-sm">
                <div class="card-body">
                  <h4 class="card-title text-primary">Our Mission</h4>
                  <p class="card-text">
                    To provide high-quality, affordable, and patient-centered care across all medical specialties, while advancing health outcomes through continuous learning and ethical practices.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>

      <Footer />
    </>
  )
}

export default About